import type { Container, Sprite, Text } from 'pixi.js';
import { onLayoutPopulated } from '../populate';

type RotationData = {
  rotationCycle: number;
};

type DisplayObjectWithRotateData = (Sprite | Container | Text) & { data: RotationData };

export function layoutRotateSPL(): void {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  onLayoutPopulated.connect((layout: { root: Container; rotate_SPL?: DisplayObjectWithRotateData[] }) => {
    if (!layout.rotate_SPL) return;

    layout.rotate_SPL.forEach((object) => {
      const cycle = object.data?.rotationCycle ?? 20000;
      object.tweenTo({ angle: object.angle + 360 }, cycle, 'linear', true, 0, -1, false);
    });
  });
}
